<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <div class="design">
        <i class="el-icon-plus"></i>
      </div>
      <p>{{ placeholder }} {{ sizeTip }}</p>
    </div>
    <div v-else>
      <!-- with-credentials -->
      <!--      <el-upload-->
      <!--          :headers="headers"-->
      <!--          :disabled="r"-->
      <!--          :file-list="_value"-->
      <!--          :action="uploadImgUrl"-->
      <!--          :limit="maxSize"-->
      <!--          :multiple="maxSize > 0"-->
      <!--          :data="uploadParams"-->
      <!--          :on-success="handleUploadSuccess"-->
      <!--          list-type="picture-card"-->
      <!--          :before-upload="beforeUpload"-->
      <!--          :on-remove="handleRemove"-->
      <!--          :on-preview="handlePictureCardPreview"-->
      <!--      >-->
      <el-upload
          multiple
          :headers="headers"
          :disabled="r"
          :file-list="_value"
          :action="uploadImgUrl"
          :limit="maxSize"
          :data="uploadParams"
          :on-success="handleUploadSuccess"
          list-type="picture-card"
          :before-upload="beforeUpload"
          :on-remove="handleRemove"
          :on-preview="handlePictureCardPreview"
      >
        <!-- :auto-upload="false" -->
        <i slot="default" class="el-icon-plus"></i>
        <!-- <div slot="file" slot-scope="{ file }">
          <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
          <span class="el-upload-list__item-actions">
            <span
              class="el-upload-list__item-preview"
              @click="handlePictureCardPreview(file)"
            >
              <i class="el-icon-zoom-in"></i>
            </span>
            <span
              v-if="!disabled"
              class="el-upload-list__item-delete"
              @click="handleDownload(file)"
            >
              <i class="el-icon-download"></i>
            </span>
            <span
              v-if="!disabled"
              class="el-upload-list__item-delete"
              @click="handleRemove(file)"
            >
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </div> -->
        <div slot="tip" class="el-upload__tip">{{ placeholder }} {{ sizeTip }}</div>
      </el-upload>
    </div>
    <!--    <el-dialog :visible.sync="dialogVisible" title="预览" width="800" append-to-body>-->
    <!--      <img :src="dialogImageUrl" style="display: block; max-width: 100%; margin: 0 auto" />-->
    <!--      <el-image-->
    <!--          :src="dialogImageUrl"-->
    <!--          style="display: block; max-width: 100%; margin: 0 auto"-->
    <!--          :preview-src-list="[dialogImageUrl]"-->
    <!--      ></el-image>-->
    <!--    </el-dialog>-->
    <el-image-viewer
        v-if="showImgViewer"
        :on-close="closeImgViewer"
        :url-list="imagePreviewUrls"
        style="width: 80%"
        :z-index="3000"
        :initial-index="initialImgPreviewIndex"
    />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import {getToken} from '@/utils/auth'
import componentMinxins from '../ComponentMinxins'
//配置文件
import config from '@/config/index'
import {ImagePreview} from 'vant'

export default {
  mixins: [componentMinxins],
  components: {ElImageViewer},
  name: 'ImageUpload',
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      },
    },
    placeholder: {
      type: String,
      default: '请选择图片',
    },
    maxSize: {
      type: Number,
      default: 5,
    },
    maxNumber: {
      type: Number,
      default: 10,
    },
    enableZip: {
      type: Boolean,
      default: true,
    },
    config1: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  computed: {
    // _value: {
    //   get() {
    //     return this.fileList
    //   },
    //   set(value) {
    //     value.map(item => {
    //       this.imagePreviewUrls.push(item.name) // 预览图片的数组
    //     })
    //     this.fileList = value
    //   }
    // },
    sizeTip() {
      return this.maxSize > 0 ? `| 每张图不超过${this.maxSize}MB` : ''
    },
  },
  data() {
    return {
      initialImgPreviewIndex: 0, // 预览打开看到的图片下标
      imagePreviewUrls: [], // 预览图片的下标
      showImgViewer: false,
      headers: {
        Authorization: 'Bearer ' + getToken(),
      },
      disabled: false,
      uploadParams: {},
      fileList: [],
      r: false,
      uploadImgUrl: config.apiUploadUrl,
      dialogVisible: false,
      dialogImageUrl: '',
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.config1) {
        this._value = this.config1.value
        console.log(this.config1);
        console.log('仅可读仅可读11111111111')
        if (this.config1.flag == 2 || this.config1.flag == 3 || this.config1.flag == 4) {

          console.log(this.r);
          this.r = true

        } else {
          var perm = this.config1.perm
          if (perm == 'R') {
            this.r = true
          }
        }
      }
    }, 5000)
    this._value.map(item => {
      this.imagePreviewUrls.push(item.name) // 预览图片的数组
    })

  },
  methods: {
    closeImgViewer() {
      this.showImgViewer = false
    },
    handleUploadSuccess(response, file, fileList) {
      let me = this;
      if (fileList.every(item => item.status == 'success')) {
        fileList.map(item => {
          /** 这时只需要push进带有response的数据就好 */
          if (item.response) {
            me.imagePreviewUrls.push(item.response.data) // 预览图片的数组
            me.fileList.push({
              name: item.response.data,
              url: item.response.data
            })
            console.log(me.fileList)
            me._value = me.fileList
          }
        })

      }
    },
    beforeUpload(file) {
      const alows = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg']
      if (alows.indexOf(file.type) === -1) {
        this.$message.warning('存在不支持的图片格式')
      } else if (this.maxSize > 0 && file.size / 1024 / 1024 > this.maxSize) {
        this.$message.warning(`单张图片最大不超过 ${this.maxSize}MB`)
      } else {
        return true
      }
      return false
    },
    handleRemove(file, fileList) {
      console.log(file)
      const findex = this.fileList.map((f) => f.name).indexOf(file.name)
      console.log(findex, 'findex')
      if (findex > -1) {
        this.imagePreviewUrls.push(findex, 1) // 预览图片的数组
        this.fileList.splice(findex, 1)
        this._value = this.fileList
        this.$emit('input', this.listToString(this._value))
      }
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = ''
      separator = separator || ','
      for (let i in list) {
        if (list[i].url) {
          strs += list[i].url.replace(this.baseUrl, '') + separator
        }
      }
      return strs != '' ? strs.substr(0, strs.length - 1) : ''
    },
    handlePictureCardPreview(file) {
      if (window.__wxjs_environment === 'miniprogram') {
        const urls = file.url.split(',')
        ImagePreview({
          images: urls,
        })
      } else {
        console.log(file.url)
        // alert('请在微信小程序中打开')
        // this.dialogImageUrl = file.url
        let index = this.imagePreviewUrls.indexOf(file.url)
        if (index >= 0) {
          this.initialImgPreviewIndex = index
        }
        this.showImgViewer = true
        // window.open(url, '_blank')
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        // this.$router.push(path);
      }
    },
    handleDownload(file) {
      console.log(file)
    },
  },
}
</script>

<style lang="less" scoped>
.design {
  i {
    padding: 10px;
    font-size: xx-large;
    background: white;
    border: 1px dashed #8c8c8c;
  }
}

/deep/ .el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 87px;
}

/deep/ .el-upload-list__item {
  width: 80px;
  height: 80px;

  .el-upload-list__item-actions {
    & > span + span {
      margin: 1px;
    }
  }
}
</style>

